import { vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled", "rows", "placeholder"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _withDirectives((_openBlock(), _createElementBlock("textarea", {
    ref: "input",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.value) = $event)),
    disabled: $props.editorDisabled,
    class: "mobile-input",
    rows: $data.rows,
    placeholder: $props.placeholder,
    maxlength: "2048",
    onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers((...args) => ($options.onKeyEnter && $options.onKeyEnter(...args)), ["stop"]), ["enter"]))
  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_1)), [
    [_vModelText, _ctx.value]
  ])
}